<template>
  <div class="container top-level-div">
    <div class="content-block">
      <h1 class="dashboard-heading" ref="pageTitle">What is Global Health?</h1>
      <hr>
      <div v-if="!editing">
        <!-- <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p>
        <p class="informational-text-block"></p> -->
        <pre v-html="content.content"></pre>


        <!-- <div v-if="$store.getters.isAuthenticated"> -->
        <div v-if="user.is_agent">
          <hr>
          <button class="mylisting-button dark-button">Edit</button>
        </div>

        <!-- {{ user }} -->
      </div>

      <div v-if="editing">
        <div>
          <div class="editor">
            <editor-menu-bar :editor="contentEditor" v-slot="{ commands, isActive }" class="mb-1">
              <div class="menubar">
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                  <strong>B</strong>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                  <i>Italics</i>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                  <u>U</u>
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                  Image
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                  H1
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                  H2
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                  H3
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                  List
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                  1. 2. 3...
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                  ""
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                  ---
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                  Undo
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                  Redo
                </button> -->
              </div>
            </editor-menu-bar>
            <editor-content class="editor__content" :editor="contentEditor" />
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import axios from 'axios'

  // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
  // Import the editor
  import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
  // import Icon from 'Components/Icon'
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
  } from 'tiptap-extensions'

  import Modal from "../employers/profile/Modal";

  export default {
    data() {
      return {
        editing: false,
        content: '',
        contentObject: {},
        // postID: null,

        user: {},
        contentEditor: null,
      }
    },
    components: {
      EditorContent,
      EditorMenuBar,

      Modal,
    },
    mounted() {
      document.title = this.$refs.pageTitle.innerHTML

      this.contentEditor = new Editor({
        content: this.content,
        autoFocus: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
        ],
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          // this.html = getHTML()
          this.content = getHTML()
        },
      })
    },
    created() {
      // Scroll the window to the top on load, since most people will get here via footer
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

      this.getContent()

      if (this.$store.getters.isAuthenticated){
        this.getUser()
      }
    },
    methods: {
      getContent() {
        axios.get('/api/contentpages/?agency=4&title=What is Global Health')
          .then(res => {
            console.log(res.data)
            this.contentObject = res.data
            this.content = this.contentObject.content

            // axios.get('/api/people/'.concat(this.job.poster.toString()))
            //   .then(res => {
            //     console.log(res.data)
            //     this.employer = res.data
            //   })
          })
          .catch(error => console.log(error))
      },
      getUser() {
        axios.get('/api/people/'+this.$store.getters.userID.toString())
          .then(res => {
            this.user = res.data
          })
          .catch(error => console.log(error))
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/general/What.vue